import React from "react";
import "../styles/Procesamiento.css";

const Procesamiento = () => {
  return (
    <div className="presentation-page pt-16">
      <header className="procesamiento-hero-section">
        <div className="procesamiento-hero-content">
          <div className="procesamiento-hero-container">
            <div className="procesamiento-hero-card">
              <div className="procesamiento-hero-grid">
                <div className="procesamiento-hero-left">
                  <h1 className="procesamiento-hero-title">
                    <span className="procesamiento-hero-title-gradient">Procesamiento</span> y Análisis de la
                    <span className="procesamiento-hero-title-gradient"> Información</span>
                  </h1>
                </div>
                <div className="procesamiento-hero-right">
                  <p className="procesamiento-hero-description">
                    Conoce cómo se procesan, analizan y difunden los datos sísmicos registrados por la Red Sísmica del
                    Noroeste de México. Desde la captura hasta la disponibilidad pública de la información.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Procesamiento de la Información Section */}
      <section className="procesamiento-procesamiento-section">
        <div className="procesamiento-procesamiento-container">
          <div className="procesamiento-procesamiento-content">
            <div className="procesamiento-procesamiento-text">
              <h2 className="procesamiento-procesamiento-title">
                <span className="procesamiento-procesamiento-title-gradient">Procesamiento</span> de la Información
              </h2>
              <p className="procesamiento-procesamiento-description">
                Análisis automático de datos sísmicos en tiempo real
              </p>
              <p className="procesamiento-procesamiento-text">
                Tras el arribo de las señales sísmicas a la sala de procesamiento de datos de la RESNOM, se analizan y procesan a través del
                sistema Earthworm / AQMS inicialmente para la detección automática de sismos, el cálculo de tiempos de
                arribo, la localización de epicentros y el cálculo de las magnitudes. 
              </p>
              <p className="procesamiento-procesamiento-text">
                Este proceso se realiza de manera automática, sin la intervención de un técnico analista de datos.
                Posteriormente, esta información, en la etapa de post-proceso es revisada por un analista, y en caso de
                ser necesario, se vuelven a procesar los registros del sismo.
              </p>
            </div>
            <div className="procesamiento-procesamiento-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/procesamiento-1.png`} alt="Procesamiento de datos" />
            </div>
          </div>
        </div>
      </section>

      {/* Intercambio de Series de Tiempo Section */}
      <section className="procesamiento-intercambio-section">
        <div className="procesamiento-intercambio-container">
          <div className="procesamiento-intercambio-content">
            <div className="procesamiento-intercambio-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/procesamiento-2.png`} alt="Intercambio de datos" />
            </div>
            <div className="procesamiento-intercambio-text">
              <h2 className="procesamiento-intercambio-title">
                Intercambio de
                <span className="procesamiento-intercambio-title-gradient"> Series de Tiempo</span>
              </h2>
              <p className="procesamiento-intercambio-description">
                Colaboración internacional para el intercambio de datos sísmicos
              </p>
              <p className="procesamiento-intercambio-text">
               El sismo del 4 de abril de 2010 (M=7.2) en la región de Baja California, México, marcó un punto importante para la red sísmica:
               la expansión de su infraestructura y la incorporación del registro de datos en tiempo real vía Internet abrieron la posibilidad de 
               establecer intercambio de información con el Servicion Sismólogico Nacional (SSN) de México y la Red Sísmica del Sur de California
              (SCSN, por sus siglas en inglés) de Estados Unidos. En la actualidad, se reciben señales de 5 estaciones del SSN, 11 estaciones del 
               SCSN y 16 estaciones de la Red Sísmica de Banda Ancha (RESBAN) operada por CICESE, cuyo monitoreo se concentra principalmente la 
               actividad sísmica del Golfo de California.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Difusión de la Información Section */}
      <section className="procesamiento-difusion-section">
        <div className="procesamiento-difusion-container">
          <div className="procesamiento-difusion-content">
            <div className="procesamiento-difusion-text">
              <h2 className="procesamiento-difusion-title">
                <span className="procesamiento-difusion-title-gradient">Difusión</span> de la Información
              </h2>
              <p className="procesamiento-difusion-description">
                Múltiples canales para la distribución de información sísmica
              </p>

              <div className="procesamiento-difusion-grid">
                <div className="procesamiento-difusion-item">
                  <div className="procesamiento-difusion-icon">
                    <i className="fas fa-file-alt"></i>
                  </div>
                  <div className="procesamiento-difusion-content-item">
                    <h3 className="procesamiento-difusion-item-title">Boletines de Información Sísmica</h3>
                    <p className="procesamiento-difusion-item-text">
                      Contienen tiempos de arribo, localizaciones hipocentrales y valores de magnitud de los sismos
                      registrados. A partir del año 2003, los boletines se envían al Centro Internacional de Sismología
                      (ISC, por sus siglas en inglés).
                    </p>
                  </div>
                </div>

                <div className="procesamiento-difusion-item">
                  <div className="procesamiento-difusion-icon">
                    <i className="fas fa-globe"></i>
                  </div>
                  <div className="procesamiento-difusion-content-item">
                    <h3 className="procesamiento-difusion-item-title">Página Web</h3>
                    <p className="procesamiento-difusion-item-text">
                      Permite consultar los reportes de la sismicidad reciente generados de manera automática, los
                      catálogos de la actividad sísmica semanal y mensual, la base de datos con la sismicidad histórica
                      registrada por la red, los boletines de información sísmica y la información de la red en general.
                    </p>
                  </div>
                </div>

                <div className="procesamiento-difusion-item">
                  <div className="procesamiento-difusion-icon">
                    <i className="fas fa-mobile-alt"></i>
                  </div>
                  <div className="procesamiento-difusion-content-item">
                    <h3 className="procesamiento-difusion-item-title">Aplicación RESNOM</h3>
                    <p className="procesamiento-difusion-item-text">
                      En el año 2012, RESNOM en colaboración con la compañía Happy Discover, lanzó una aplicación
                      gratuita (disponible para Apple y Android), desde la cual los usuarios pueden consultar la
                      información generada por la Red Sísmica del Noroeste de México.
                    </p>
                  </div>
                </div>
              </div>

    
            </div>
            <div className="procesamiento-difusion-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/mockups.png`} alt="Aplicación móvil" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Procesamiento;
